import { Component } from '@angular/core';

@Component({
  selector: 'app-check-circle-icon',
  standalone: true,
  templateUrl: './check-circle-icon.component.html',
})
export class CheckCircleIconComponent {}
